import { ScrollingModule } from '@angular/cdk/scrolling';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { provideRouter, RouterModule, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CustomerSelectionModule } from '@next/arable-lib/customer-selection';
import { CoreEffects } from '@next/core-lib';
import { provideAgrAdvisorRelationshipsSelector } from '@next/core-lib/advisor-relationships-selector';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { IgnoreStatusOfflinePatterns } from '@next/core-lib/components';
import { provideAgrElasticApi } from '@next/core-lib/elastic';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';

import { appRoutes } from './app.routes';
import { OrderplanningCustomerSelectionCustomConfigComponent } from './customer-selection-custom-config/customer-selection-custom-config.component';
import { FertilisersOverviewModule } from './fertilisers-overview/fertilisers-overview.module';
import { LocationInterceptor } from './location.interceptor';
import { OverviewModule } from './overview/overview.module';
import { OverviewV2Module } from './overview-v2/overview-v2.module';
import { OrderplanningValidationErrorInterceptor } from './shared/interceptors/orderplanning-validation-error.interceptor';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent, OrderplanningCustomerSelectionCustomConfigComponent],
  imports: [
    RouterModule,
    SharedModule,
    OverviewModule,
    OverviewV2Module,
    FertilisersOverviewModule,
    MatIconModule,
    AgrWrapperSiteSidenavModule,
    ScrollingModule,
    CustomerSelectionModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrAdvisorRelationshipsSelector(),
    provideAgrElasticApi(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects, AppEffects]),
    provideState('app', appReducer),
    {
      provide: IgnoreStatusOfflinePatterns,
      useValue: ['/arable-service/organisation/customerprogress'],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LocationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: OrderplanningValidationErrorInterceptor, multi: true },
  ],
})
export class AppModule {}
